<template>
  <div class="nav-bar" style="background-color: white">
    <div v-if="isOrderEmpty" style="text-align: center; padding-top: 1rem">
      ไม่พบรายการคำสั่งซื้อ
    </div>
    <div v-if="searchErrorMessage" style="text-align: center; padding-top: 1rem">
      {{ searchErrorMessage }}
    </div>
    <div v-if="searchErrorMessage || searchResult || searchOrderLoading">
      <div v-for="(item, date) in searchResult" :key="date">
        <div v-for="(orders, status) in item" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrderShipping
                @onclick="ShowDirection"
                @oncancelOrder="onCancelOrder"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :driverName="order.driverName"
                :name="order.name"
                :price="order.price"
                :status="order.status"
                :origin="order.origin"
                :updatedAt="order.updatedAt"
                :destination="order.destination"
                :lalamoveTag="order.riderType"
                :destinationLocation="order.destinationLocation"
              >
              </CardOrderShipping>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="orderList">
      <div v-for="(item, date) in orderList" :key="date">
        <div v-for="(orders, status) in item" :key="orders.priority">
          <div v-if="orders.items.length > 0">
            <div v-if="canShowItems(status)">
              <div class="title">
                <p>{{ status }} ({{ orders.items.length }})</p>
                <p>{{ date }}</p>
              </div>
              <CardOrderShipping
                @onclick="ShowDirection"
                @oncancelOrder="onCancelOrder"
                v-for="order in orders.items"
                :key="order.id"
                :id="order.id"
                :time="order.time"
                :date="order.date.date"
                :driverName="order.driverName"
                :name="order.name"
                :price="order.price"
                :status="order.status"
                :origin="order.origin"
                :updatedAt="order.updatedAt"
                :destination="order.destination"
                :lalamoveTag="order.riderType"
                :destinationLocation="order.destinationLocation"
              >
              </CardOrderShipping>
              <div
                v-if="nextToken[date][status]"
                @click="onLoadmoreData(date, status)"
                class="icon-loadmore"
              >
                <b-icon icon="arrow-down-drop-circle-outline" size="is-medium"> </b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { statusByRouteName } from "@/settings/orderStatus";
export default {
  name: "ShipingOrder",
  components: {
    CardOrderShipping: () => import("@/components/CardOrderShipping"),
    // CardShipping: () => import("@/components/CardShipping"),
  },
  data() {
    return {
      isLoading: null,
    };
  },
  computed: {
    orderList() {
      return this.$store.getters["orders/orders"];
    },
    nextToken() {
      return this.$store.getters["orders/nextToken"];
    },
    filter() {
      return this.$store.getters["orders/filter"];
    },
    // countdown(time) {
    //   this.setinterval = setInterval(() => {
    //     let current = new Date() - new Date(time);
    //     return new Date(current).toLocaleTimeString("it-IT");
    //   }, 1000);
    // },
    isOrderEmpty() {
      const status = statusByRouteName[this.$route.name];
      return this.$store.getters["orders/isOrderEmpty"](status);
    },
    searchResult() {
      return this.$store.getters["orders/searchResult"];
    },
    searchErrorMessage() {
      return this.$store.getters["orders/searchErrorMessage"];
    },
    searchOrderLoading() {
      return this.$store.getters["orders/searchOrderLoading"];
    },
    loadingOrder() {
      return this.$store.getters["orders/loadingOrder"];
    },
  },
  async mounted() {
    this.$store.commit("orders/setEmptyOrders");
    this.getOrderList();
    // await Promise.all([
    //   this.$store.dispatch("orders/getOrders", "PICKUP"),
    //   this.$store.dispatch("orders/getOrders", "DERIVERING"),
    // ]);
    // this.$store.commit("orders/setLoadingOrder", true);
  },
  watch: {
    loadingOrder() {
      console.log("loadingOrder", this.loadingOrder);
      if (!this.loadingOrder) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
    searchOrderLoading() {
      console.log("searchOrderLoading", this.searchOrderLoading);
      if (this.searchOrderLoading) {
        this.isLoading = this.$buefy.loading.open();
      } else {
        if (this.isLoading) {
          this.isLoading.close();
        }
      }
    },
  },
  methods: {
    async getOrderList() {
      this.$store.commit("orders/setLoadingOrder", false);
      await Promise.all([
        await this.$store.dispatch("orders/getOrders", { status: "PICKUP" }),
        await this.$store.dispatch("orders/getOrders", { status: "DERIVERING" }),
      ]);
      this.$store.commit("orders/setLoadingOrder", true);
    },
    ShowDirection(position) {
      position;
      const EventBus = this.$root;
      EventBus.$emit("ShowDirection", position, "position");
    },
    async onCancelOrder(order) {
      const result = await this.$store.dispatch("orders/updateOrder", {
        orderId: order.id,
        nStatus: "CANCELBYADMIN",
        oStatus: "PICKUP",
        date: order.date.date,
      });
      if (result) {
        this.$buefy.toast.open({
          message: "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว!",
          type: "is-danger",
        });
        this.$router.push("/shippingOrder");
      }
    },
    async onLoadmoreData(date, status) {
      console.log(date);
      if (this.filter) {
        console.log(this.filter, this.nextToken);
        await this.$store.dispatch("orders/getOrdersWithFilter", {
          ...this.filter,
          date: date,
          status: status,
          nextToken: this.nextToken[date][status],
        });
      } else {
        await this.$store.dispatch("orders/getOrders", {
          status: status,
          nextToken: this.nextToken[date][status],
        });
      }
    },
    // CountDownTime(time) {},
    canShowItems(status) {
      const allowedStatus = statusByRouteName[this.$route.name] ?? [];
      // console.log("canShowItems", status, allowedStatus);

      // search mode
      // const isSearchOrderMode = this.$store.getters["orders/isSearchOrderMode"];
      // if (isSearchOrderMode) {
      //   status = "ALL";
      // }

      // if (this.selectedStatus !== "ALL") {
      //   return status === this.selectedStatus;
      // }

      return allowedStatus.includes(status);
    },
  },
};
</script>
<style scoped>
.title {
  z-index: 10;
  font-size: 15px;
  padding: 10px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
  display: flex;
  justify-content: space-between;
}
.icon-loadmore {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}
</style>
